module.exports = __webpack_public_path__ + "static/media/ad_work_flow.fe93f065.svg";